import * as FS from 'file-saver';
import { 
    HeightReference, LabelStyle, Color, VerticalOrigin, HorizontalOrigin, NearFarScalar, 
    Cartesian3, Cartographic, ArcType, Math, Cesium3DTileStyle as CesiumDataSourceStyle, BillboardGraphics
} from 'cesium';         

import * as Cesium from 'cesium';
Cesium.Ion.defaultAccessToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI4ZGU0YWFlNC0yNzhmLTQ1ODktOWYyMy03MTQ0NDI3MjBiNTUiLCJpZCI6MTU1MDEsInNjb3BlcyI6WyJhc3IiLCJnYyJdLCJpYXQiOjE1NjgwOTU2MDB9.lx6MdiuOH_dSwYAaQ6G9bgakecWQGxBbQ19TFQPxLEY'

var heightReferenceLookup = Object.keys(HeightReference).reduce(function(acc, key) {
    return acc[HeightReference[key]] = key, acc;
}, {});
var verticalOriginLookup = Object.keys(VerticalOrigin).reduce(function(acc, key) {
    return acc[VerticalOrigin[key]] = key, acc;
}, {});
var horizontalOriginLookup = Object.keys(HorizontalOrigin).reduce(function(acc, key) {
    return acc[HorizontalOrigin[key]] = key, acc;
}, {});
var labelStyleLookup = Object.keys(LabelStyle).reduce(function(acc, key) {
    return acc[LabelStyle[key]] = key, acc;
}, {});

export function setDefaultStyle(dataSource) {

    var entity = dataSource.entities.values[0];
    dataSource._documentPacket = {};
    if (entity.polygon) {
        return JSON.stringify({
            name: dataSource.name,
            type: "polygon",
            color: [255, 0, 0, 255],
            heightReference: "CLAMP_TO_GROUND"
        })
    }
    else if (entity.billboard) {
        var type = dataSource.entities.values.length === 1 ? "billboard" : "billboardCollection";
        return JSON.stringify({
            name: dataSource.name, 
            type, 
            image: "https://myglobe.app/uploads/rous/media/icons/Marker_WTP.svg", 
            nearFarScalar: [ 10000.0, 0.4, 100000.0, 0.3 ],
            heightReference: "CLAMP_TO_GROUND",
            verticalOrigin: "BOTTOM",               
            disableDepthTestDistance: 0.0,
            position: type === "billboard" ? [
                153.343519,
                -28.62693,
                0
            ] : undefined
        });
    }
    else if (entity.polyline) {
        return JSON.stringify({
            name: dataSource.name,
            type: "polyline",
            color: [255, 0, 0, 255],
            clampToGround: true,
            width: 5,
        })
    }
    else
        return "";     
}

/**
     * Function: visLayer style update
     * ------------------------
     * Handles incoming view state prop transitions
     * and layer updates
     */
export function styleVisLayer(styles, viewer, dataset = null) {
        console.log(styles);
        if (styles) {
            var name = styles.visLayerName;
            if (dataset === null)
                dataset = viewer.current.dataSources.getByName(name)[0];
            if (dataset) {
                let {type, name, styleExpression} = styles.styleJSON;
                dataset._documentPacket = {styleExpression};
                dataset.name = name;
                switch (type) {
                    case "polygon": { stylePolygon(styles.styleJSON, dataset) } break;
                    case "billboardCollection":
                    case "billboard": { styleBillboard(styles.styleJSON, dataset)} break;
                    case "polyline": { stylePolyline(styles.styleJSON, dataset)} break;
                    case "label":
                    case "labelCollection": { styleLabel(styles.styleJSON, dataset)} break;
                }
            }
        }
    }

    function styleLabel(styles, dataset) {
        
        let { text, font, outlineColor, outlineWidth, fillColor,
            style, styleExpression,
            nearFarScalar, heightReference, disableDepthTestDistance, 
            horizontalOrigin, verticalOrigin, position, labelCluster } = styles;
        var styleExp = new CesiumDataSourceStyle(styleExpression);  
        if (!styleExp.scaleByDistance ) styleExp.scaleByDistance = nearFarScalar && 'vec4'+Cesium.Cartesian4.unpack(nearFarScalar).toString();
        if (!styleExp.disableDepthTestDistance) styleExp.disableDepthTestDistance = disableDepthTestDistance;
        if (!styleExp.verticalOrigin) styleExp.verticalOrigin = VerticalOrigin[verticalOrigin];
        if (!styleExp.horizontalOrigin) styleExp.horizontalOrigin = HorizontalOrigin[horizontalOrigin];
        if (!styleExp.labelStyle) styleExp.labelStyle = LabelStyle[style];
        if (!styleExp.labelText) styleExp.labelText = text;
        if (!styleExp.font) styleExp.font = `'${font}'`;
        if (!styleExp.labelOutlineWidth) styleExp.labelOutlineWidth = outlineWidth;
        if (!styleExp.labelOutlineColor) styleExp.labelOutlineColor = outlineColor && 'rgba'+Color.unpack(outlineColor.map((i,idx) => idx === outlineColor.length - 1 ? i / 255 : i)).toString();
        if (!styleExp.labelColor) styleExp.labelColor = fillColor && 'rgba'+Color.unpack(fillColor.map((i,idx) => idx === fillColor.length - 1 ? i / 255 : i)).toString();
        if (!styleExp.show) styleExp.show = true;
        var nearFarScalarArray = [];
        
        dataset?.entities?.values.forEach( (entity) => {
            if (!entity.label) { entity.label = new Cesium.LabelGraphics(); if (entity.billboard) entity.billboard = undefined; }
            if (heightReference) entity.label.heightReference = HeightReference[heightReference];
            if (styleExp.disableDepthTestDistance) entity.label.disableDepthTestDistance = styleExp.disableDepthTestDistance.evaluate(entity);
            if (styleExp.labelText) entity.label.text = styleExp.labelText.evaluate(entity);
            if (styleExp.font) entity.label.font = styleExp.font.evaluate(entity);
            if (styleExp.labelColor) entity.label.fillColor = styleExp.labelColor.evaluateColor(entity);
            if (styleExp.labelOutlineColor) entity.label.outlineColor = styleExp.labelOutlineColor.evaluateColor(entity);
            if (styleExp.labelOutlineWidth) entity.label.outlineWidth = styleExp.labelOutlineWidth.evaluate(entity);
            if (styleExp.labelStyle) entity.label.style = styleExp.labelStyle.evaluate(entity);
            if (styleExp.horizontalOrigin) entity.label.horizontalOrigin = styleExp.horizontalOrigin.evaluate(entity);
            if (styleExp.verticalOrigin) entity.label.verticalOrigin = styleExp.verticalOrigin.evaluate(entity);
            if (styleExp.scaleByDistance) entity.label.scaleByDistance = Cesium.NearFarScalar.unpack(Cesium.Cartesian4.pack(styleExp.scaleByDistance.evaluate(entity),nearFarScalarArray));
            if (position) entity.position = Cartesian3.fromDegreesArrayHeights(position)[0];
            if (styleExp.show) entity.label.show = styleExp.show.evaluate(entity);
        })
        if (labelCluster) {
            console.log(labelCluster);
            var pixelRange = labelCluster.pixelRange || 5;
            var minimumClusterSize = labelCluster.minimumClusterSize || 2;
            
            dataset.clustering.enabled = true;
            dataset.clustering.pixelRange = pixelRange;
            dataset.clustering.minimumClusterSize = minimumClusterSize;
            var removeListener;

            function customStyle() {
                if (Cesium.defined(removeListener)) {
                    removeListener();
                    removeListener = undefined;
                } else {
                    removeListener = dataset.clustering.clusterEvent.addEventListener(
                        function (clusteredEntities, cluster) {
                            cluster.label.show = false;
                            if (!cluster.billboard) cluster.billboard = new BillboardGraphics();
                            cluster.billboard.show = true;
                            cluster.billboard.id = cluster.label.id;
                            cluster.billboard.verticalOrigin = VerticalOrigin.BOTTOM;                  
                            cluster.billboard.image = labelCluster.image;
                            cluster.billboard.scale = labelCluster.scale || 1;
                            cluster.billboard.heightReference = HeightReference.CLAMP_TO_GROUND
                            cluster.billboard.eyeOffset = new Cartesian3(0.0, 0.0, -1000.0);
                        }
                    );
                }
        
                // force a re-cluster with the new styling
                var pixelRange = dataset.clustering.pixelRange;
                dataset.clustering.pixelRange = 0;
                dataset.clustering.pixelRange = pixelRange;
            }
            customStyle();
        }
    }

    function stylePolyline(style, dataset) {
        const {color, width, clampToGround, styleExpression} = style;
        var style = new CesiumDataSourceStyle(styleExpression);
        if (!style.color) style.color = 'rgba'+Color.unpack(color.map((i,idx) => idx === color.length - 1 ? i / 255 : i)).toString();
        if (!style.lineWidth) style.lineWidth = width;
        if (!style.show) style.show = true;
        dataset?.entities?.values.forEach( (entity) => {
            if (style.color) entity.polyline.material = style.color.evaluateColor(entity);
            if (clampToGround) entity.polyline.clampToGround = clampToGround;
            if (style.lineWidth) entity.polyline.width = style.lineWidth.evaluate(entity);
            if (style.show) entity.polyline.show = style.show.evaluate(entity);
        })
    }

    function stylePolygon(style, dataset) {
        const {color, heightReference, styleExpression} = style;
        var style = new CesiumDataSourceStyle(styleExpression);
        if (!style.color) style.color = 'rgba'+Color.unpack(color.map((i,idx) => idx === color.length - 1 ? i / 255 : i)).toString();            
        if (!style.show) style.show = true;
        dataset?.entities?.values.forEach( (entity) => {
            entity.polygon.arcType = ArcType.GEODESIC;                
            if (style.color) entity.polygon.material = style.color.evaluateColor(entity);
            if (heightReference) entity.polygon.heightReference = HeightReference[heightReference];
            if (HeightReference[heightReference] === HeightReference.CLAMP_TO_GROUND) entity.polygon.height = undefined;
            if (HeightReference[heightReference] === HeightReference.CLAMP_TO_GROUND) entity.polygon.perPositionHeight = undefined;
            if (style.show) entity.polygon.show = style.show.evaluate(entity);
        })
    }

    function styleBillboard(style, dataset) {
        let {image, nearFarScalar, heightReference, disableDepthTestDistance, verticalOrigin, position, styleExpression} = style;
        var style = new CesiumDataSourceStyle(styleExpression);
        if (!style.image) style.image = `'${image}'`;
        if (!style.scaleByDistance ) style.scaleByDistance = 'vec4'+Cesium.Cartesian4.unpack(nearFarScalar).toString();
        if (!style.disableDepthTestDistance) style.disableDepthTestDistance = disableDepthTestDistance;
        if (!style.verticalOrigin) style.verticalOrigin = VerticalOrigin[verticalOrigin];
        if (!style.show) style.show = true;
        var nearFarScalarArray = [];
        dataset?.entities?.values.forEach( (entity) => {
            if (!entity.billboard) { entity.billboard = new Cesium.BillboardGraphics(); entity.label = null }
            if (style.image) entity.billboard.image = style.image.evaluate(entity);
            if (style.scaleByDistance) entity.billboard.scaleByDistance = Cesium.NearFarScalar.unpack(Cesium.Cartesian4.pack(style.scaleByDistance.evaluate(entity),nearFarScalarArray));
            if (style.disableDepthTestDistance) entity.billboard.disableDepthTestDistance = style.disableDepthTestDistance.evaluate(entity);
            if (verticalOrigin) entity.billboard.verticalOrigin = style.verticalOrigin.evaluate(entity);
            if (heightReference) entity.billboard.heightReference = HeightReference[heightReference];
            if (position) entity.position = Cartesian3.fromDegreesArrayHeights(position)[0];
            if (style.show) entity.billboard.show = style.show.evaluate(entity);
        })
    }

export function getStyle(dataset, viewer) {
        var entity = dataset.entities.values[0];
        var styleExpression = dataset?._documentPacket?.styleExpression;
        if (entity.polygon) {
            var colorArray = [];
            return { name: dataset.name, style: JSON.stringify({
                styleExpression: styleExpression,
                name: dataset.name,
                type: "polygon",
                heightReference: heightReferenceLookup[entity.polygon.heightReference.getValue()],
                color: Color.pack(entity.polygon.material.color.getValue(),colorArray).map( c => c * 255.0)
            })};
        }
        if (entity.billboard) {
            var type = dataset.entities.values.length === 1 ? "billboard" : "billboardCollection";
            let position = entity.position && Cartographic.fromCartesian(entity.position.getValue(viewer.current.clock.currentTime))
            var nearFarScalarArray = [];
            return { name: dataset.name, style: JSON.stringify({
                styleExpression: styleExpression,
                name: dataset.name,
                type,
                image: entity.billboard.image.getValue()._url,
                nearFarScalar: NearFarScalar.pack(entity.billboard.scaleByDistance.getValue(),nearFarScalarArray),
                heightReference: heightReferenceLookup[entity.billboard.heightReference.getValue()],
                disableDepthTestDistance: entity.billboard.disableDepthTestDistance.getValue(),
                verticalOrigin: verticalOriginLookup[entity.billboard.verticalOrigin.getValue()],
                position: type === "billboard" ? [
                    Math.toDegrees(position.longitude),
                    Math.toDegrees(position.latitude),
                    position.height
                ] : undefined
            })}
        }
        if (entity.label) {
            var type = dataset.entities.values.length === 1 ? "label" : "labelCollection";
            let position = entity.position && Cartographic.fromCartesian(entity.position.getValue(viewer.current.clock.currentTime))
            var nearFarScalarArray = [];
            var fillColorArray = [];
            var outlineColorArray = [];
            return { name: dataset.name, style: JSON.stringify({
                styleExpression: styleExpression,
                name: dataset.name,
                type,
                heightReference: entity.label.heightReference && heightReferenceLookup[entity.label.heightReference.getValue()],
                disableDepthTestDistance: entity.label.disableDepthTestDistance && entity.label.disableDepthTestDistance.getValue(),
                text: entity.label.text && type === "label" ? entity.label.text.getValue() : undefined,
                font: entity.label.font && entity.label.font.getValue(),
                fillColor: entity.label.fillColor && Color.pack(entity.label.fillColor.getValue(),fillColorArray).map( c => c * 255.0),
                outlineColor: entity.label.outlineColor && Color.pack(entity.label.outlineColor.getValue(),outlineColorArray).map( c => c * 255.0),
                outlineWidth: entity.label.outlineWidth && entity.label.outlineWidth.getValue(),
                style: entity.label.style && labelStyleLookup[entity.label.style.getValue()],
                horizontalOrigin: entity.label.horizontalOrigin && horizontalOriginLookup[entity.label.horizontalOrigin.getValue()],
                disableDepthTestDistance: entity.label.disableDepthTestDistance && entity.label.disableDepthTestDistance.getValue(),
			    nearFarScalar: entity.label.scaleByDistance && NearFarScalar.pack(entity.label.scaleByDistance.getValue(),nearFarScalarArray),
                verticalOrigin: entity.label.verticalOrigin && verticalOriginLookup[entity.label.verticalOrigin.getValue()],
                position: position && type === "label" ? [
                    Math.toDegrees(position.longitude),
                    Math.toDegrees(position.latitude),
                    position.height
                ] : undefined
            })}
        }
        if (entity.polyline) {
            var colorArray = [];
            return { name: dataset.name, style: JSON.stringify({
                styleExpression: styleExpression,
                name: dataset.name,
                type: "polyline",
                clampToGround: entity.polyline.clampToGround.getValue(),
                color: Color.pack(entity.polyline.material.color.getValue(),colorArray).map( c => c * 255.0),
                width: entity.polyline.width.getValue()
            })};
        }
    }

export function saveCZML(vis,filename,viewer)  {
        var dataset = viewer.current.dataSources.getByName(vis.Name)[0];
        console.log(dataset);
        var CZML = [
            {
                id: 'document',
                name: vis.Name,
                version: "1.0",
                styleExpression: dataset?._documentPacket?.styleExpression
            }
        ];
        dataset?.entities?.values.forEach( (entity) => {
            let position = entity.position && Cartographic.fromCartesian(entity.position.getValue(viewer.current.clock.currentTime))
            var czmlItem = {
                id: entity.id,
                name: entity.name,
                description: entity.description.getValue(),
                properties: entity.properties && entity.properties.getValue(viewer.current.clock.currentTime), // czml needs entity.properties.geojsonProps.getValue()
                position: position && { cartographicDegrees: [Math.toDegrees(position.longitude),Math.toDegrees(position.latitude),position.height]},
            };
            if (entity.polygon) {
                czmlItem.polygon = convertPolygon(entity.polygon);
            }
            if (entity.billboard) {
                czmlItem.billboard = convertBillboard(entity.billboard);
            }
            if (entity.polyline) {
                czmlItem.polyline = convertPolyline(entity.polyline);
            }
            if (entity.label) {
                czmlItem.label = convertLabel(entity.label);
            }
            CZML.push(czmlItem);
        });
        console.log(CZML);
        console.log(JSON.stringify(CZML,null,"\t"));
        var blob = new Blob([JSON.stringify(CZML,null,"\t")], {type: "application/json;charset=utf-8"});
        FS.saveAs(blob, filename);
    }

    function convertLabel(labelGraphics) {
        let nearFarScalarArray = [];
        let outlineColorArray = [];
        let fillColorArray = [];
        return {
            heightReference: labelGraphics.heightReference && heightReferenceLookup[labelGraphics.heightReference.getValue()],
            scaleByDistance: labelGraphics.scaleByDistance && { nearFarScalar: NearFarScalar.pack(labelGraphics.scaleByDistance.getValue(), nearFarScalarArray) },
            disableDepthTestDistance: labelGraphics.disableDepthTestDistance && labelGraphics.disableDepthTestDistance.getValue(),
            horizontalOrigin: labelGraphics.horizontalOrigin && horizontalOriginLookup[labelGraphics.horizontalOrigin.getValue()],
            verticalOrigin: labelGraphics.verticalOrigin && verticalOriginLookup[labelGraphics.verticalOrigin.getValue()],
            outlineColor: labelGraphics.outlineColor && {
                rgba: Color.pack(labelGraphics.outlineColor.getValue(),outlineColorArray).map(c => c * 255.0)
            },
            fillColor: labelGraphics.fillColor && {
                rgba: Color.pack(labelGraphics.fillColor.getValue(),fillColorArray).map(c => c * 255.0)
            },
            text: labelGraphics.text && labelGraphics.text.getValue(),
            font: labelGraphics.font && labelGraphics.font.getValue(),
            outlineWidth: labelGraphics.outlineWidth && labelGraphics.outlineWidth.getValue(),
            style: labelGraphics.style && labelStyleLookup[labelGraphics.style.getValue()],
            show: labelGraphics.show.getValue()
        }
    }

    function convertPolyline(polylineGraphics) {
        let colorArray = [];
        var positions = { 
            cartographicDegrees: polylineGraphics.positions.getValue().map( (p) => {
                let carto = Cartographic.fromCartesian(p);
                return [Math.toDegrees(carto.longitude),Math.toDegrees(carto.latitude),carto.height]
            }).flat(Infinity)
        };
        return {
            positions: positions,
            clampToGround: polylineGraphics.clampToGround.getValue(),
            width: polylineGraphics.width.getValue(),
            material : {
                solidColor : {
                    color : {
                        rgba: Color.pack(polylineGraphics.material.color.getValue(),colorArray).map(c => c * 255.0)
                    }
                }
            },
            show: polylineGraphics.show.getValue()
        };
    }

    function convertBillboard(billboardGraphics) {
        let nearFarScalarArray = [];

        return {
            heightReference: heightReferenceLookup[billboardGraphics.heightReference.getValue()],
            image: billboardGraphics.image.getValue(),
            scaleByDistance: { nearFarScalar: NearFarScalar.pack(billboardGraphics.scaleByDistance.getValue(), nearFarScalarArray) },
            disableDepthTestDistance: billboardGraphics.disableDepthTestDistance && billboardGraphics.disableDepthTestDistance.getValue(),
            verticalOrigin: verticalOriginLookup[billboardGraphics.verticalOrigin.getValue()],
            show:  billboardGraphics.show.getValue()
        }
    }

    function convertPolygon(polygonGraphics){
        let colorArray = [];
        var hierarchy = polygonGraphics.hierarchy.getValue();
        var positions = { 
            cartographicDegrees: hierarchy.positions.map( (p) => {
                let carto = Cartographic.fromCartesian(p);
                return [Math.toDegrees(carto.longitude),Math.toDegrees(carto.latitude),carto.height]
            }).flat(Infinity)
        };
        var holes = { cartographicDegrees: hierarchy.holes.map( (p) => {
            return p.positions.map( (pos) => {
                let carto = Cartographic.fromCartesian(pos);
                return [Math.toDegrees(carto.longitude),Math.toDegrees(carto.latitude),carto.height]
            }).flat(Infinity);
        }) };
        return {
            positions: positions,
            heightReference: heightReferenceLookup[polygonGraphics.heightReference.getValue()],
            holes: holes,
            material : {
                solidColor : {
                    color : {
                        rgba: Color.pack(polygonGraphics.material.color.getValue(),colorArray).map(c => c * 255.0)
                    }
                }
            },
            show: polygonGraphics.show.getValue()
        };
    }